<header class="menu-buttons-page-card__header">
  <app-back-button variant="grey"></app-back-button>
  <div class="menu-buttons-page-card__text-wrapper">
    <h1 class="menu-buttons-page-card__title">{{ label }}</h1>
    <h2 class="menu-buttons-card__subtitle" *ngIf="sublabel">{{ sublabel }}</h2>
  </div>
</header>
